import Http from '../http';
import {
  CLOSE_LOANS_DRAWER,
  FETCH_LOANS,
  FETCH_LOANS_ERROR,
  FETCH_LOANS_SUCCESS,
  OPEN_LOANS_DRAWER,
} from './constants';

/* Drawer state */

export const openLoansDrawer = () => ({
  type: OPEN_LOANS_DRAWER,
});

export const closeLoansDrawer = () => ({
  type: CLOSE_LOANS_DRAWER,
});

const fetchLoansStart = () => ({
  type: FETCH_LOANS,
});

const fetchLoansSuccess = payload => ({
  type: FETCH_LOANS_SUCCESS,
  payload,
});

const fetchLoansError = () => ({
  type: FETCH_LOANS_ERROR,
});

export const fetchLoans = (ownerId, ownerType) => (dispatch) => {
  dispatch(fetchLoansStart());

  return Http.get(`/loans/${ownerType}/${ownerId}`)
    .then((data) => {
      dispatch(fetchLoansSuccess(data));
    })
    .catch(() => {
      dispatch(fetchLoansError());
    });
};

export const fetchLoansLink = (ownerId, ownerType, type) => () =>
  Http.post(`/loans/${ownerType}/${ownerId}/account-link`, {
    type,
  });

export const hideLoansPopup = (ownerId, ownerType) => () =>
  Http.post(`/loans/${ownerType}/${ownerId}/hide-popup`);

export const declineOffer = (ownerId, ownerType) => async (dispatch) => {
  const result = await Http.delete(`/loans/${ownerType}/${ownerId}`);

  dispatch(fetchLoans(ownerId, ownerType));

  return result;
};
